import { AntDesign } from "@expo/vector-icons";
import { useThemeProvider, View } from "@towersystems/roam-common-native";
import React, { useEffect, useLayoutEffect } from "react";
import { Pressable, SafeAreaView } from "react-native";
import Animated, {
  SharedValue,
  useAnimatedStyle,
  useDerivedValue,
  useSharedValue,
  withTiming,
} from "react-native-reanimated";
import { Spacings } from "react-native-ui-lib";
import { useIsFocused } from "@react-navigation/native";

export interface AccordionProps {
  children?: React.ReactNode;
  viewKey?: string;
  expanded: boolean;
  onPress?: () => void;
  header?: React.ReactNode;
  duration?: number;
}

export function Accordion({
  children,
  expanded,
  header,
  viewKey,
  onPress,
  duration = 300,
  ...props
}: AccordionProps) {
  const { colors } = useThemeProvider();
  const height = useSharedValue(0);
  const isFocused = useIsFocused();
  const [shouldAnimate, setShouldAnimate] = React.useState(false);

  useLayoutEffect(() => {
    setShouldAnimate(false);
  }, [isFocused]);

  useLayoutEffect(() => {
    setShouldAnimate(true);
  }, [expanded]);

  const derivedHeight = useDerivedValue(() => {
    return withTiming(height.value * Number(expanded), {
      duration,
    });
  });

  const bodyStyle = useAnimatedStyle(() => ({
    height: derivedHeight.value,
  }));

  const icon = expanded ? "down" : "right";

  const headerMarkup = (
    <View
      flex
      row
      centerV
      style={{
        justifyContent: "space-between",
      }}
    >
      <Pressable onPress={onPress} style={{ marginRight: Spacings.s3 }}>
        <AntDesign name={icon} size={24} color={colors.text} />
      </Pressable>
      {header}
    </View>
  );

  return (
    <SafeAreaView {...props} style={[{ overflow: "hidden" }]}>
      {headerMarkup}
      <Animated.View
        key={`accordionItem_${viewKey}_${shouldAnimate}`}
        style={[
          { overflow: "hidden" },
          shouldAnimate
            ? bodyStyle
            : expanded
            ? { height: "auto" }
            : { height: 0 },
        ]}
      >
        <View
          style={{
            width: "100%",
            // position: "absolute",
            display: "flex",
          }}
          onLayout={(e) => {
            height.value = e.nativeEvent.layout.height;
          }}
        >
          {children}
        </View>
      </Animated.View>
    </SafeAreaView>
  );
}
